<template>
  <div class="min-h-screen flex flex-col font-sans">
    <Navbar></Navbar>
    <AppMenu></AppMenu>
    <div></div>
    <main class="flex-1 p-4">
      <router-view />
      <NotificationStack />
    </main>

    <footer class="p-2 text-center text-sm text-gray-500">
      PWA • Vue 3 • Vite • Tailwind
    </footer>
  </div>
</template>


<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { getOutboxCount, drainOutbox } from './lib/db.js';
import { useAppStore } from './stores/app.js'

import Navbar from '@/components/Navbar.vue'
import AppMenu from './components/AppMenu.vue';
import NotificationStack from '@/components/notification/NotificationStack.vue';

//const queueCount = ref(QUEUED_ITEMS);

const app = useAppStore();

//const updateCount = async () => { queueCount.value = await getOutboxCount(); };


const onOnline = async () => {
  //online.value = true;
  app.setOnline(true);
  //await drainOutbox();
  //await updateCount();
};
const onOffline = () => { 
  // online.value = false; 
  app.setOnline(false);
};


onMounted(async () => {
  //await updateCount();
  window.addEventListener('online', onOnline);
  window.addEventListener('offline', onOffline);
});


onUnmounted(() => {
  window.removeEventListener('online', onOnline);
  window.removeEventListener('offline', onOffline);
});
</script>


<style>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
</style>